import React from "react";
import { useHistory } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";

export default function FeatureTopNav({ name, link, handleCreate }) {
  return (
    <div className="flex justify-between mb-2">
      <div className="font-bold text-2xl font-serif compass_color">{name}</div>
      <div className="flex">
        <AiOutlinePlus
          size={25}
          onClick={() => handleCreate()}
          className="cursor-pointer"
        />
      </div>
    </div>
  );
}
